var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"marketing-automation-detail"},[(_vm.loading)?_c('loading',{staticClass:"marketing-automation-detail-loading"}):_c('marketing-automation-form',{attrs:{"automation":_vm.automation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }